import React from "react";
import { CloseIcon } from "@icarius-icons";
import { Dialog, Grid, DialogTitle, DialogContent, Typography, List, ListItem } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";

const CollaboratorsDialog = (props) => {

  const {
    open,
    title,
    noAssociatedCollaboratorsTitle,
    data,
    nameField,
    codeField,
    handleClose,
  } = props;

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      maxWidth={"sm"}
      fullWidth
      scroll={"paper"}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {title}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingBottom: 30 }}>
        {
          data?.length > 0 && data?.map((managementCenter, index) =>
            <Grid container item xs={12} key={index} direction="column" style={{ marginBottom: 20 }}>
              <Typography align="center" variant="h5" className="whiteText" style={{ fontWeight: 500, marginTop: 10, marginBottom: 10 }}>
                {managementCenter.value}
              </Typography>
              <List className="list-round-container">
                {
                  managementCenter.assigned.map(collaborator =>
                    <ListItem key={collaborator[codeField]}>
                      <Typography align="center" variant="h6" className="whiteText" style={{ fontWeight: 100, fontSize: 16 }}>
                        {`${collaborator[nameField]} (${collaborator[codeField]})`}
                      </Typography>
                    </ListItem>
                  )
                }
                {
                  managementCenter?.assigned.length === 0 &&
                  <Typography align="center" variant="h6" className="whiteText" style={{ fontWeight: 100, fontSize: 16 }}>
                    {noAssociatedCollaboratorsTitle}
                  </Typography>
                }
              </List>
            </Grid>
          )
        }

      </DialogContent>
    </Dialog>
  );
}

export default CollaboratorsDialog;